// Retire les activités supprimées de la liste (Prise en charge, Gardiennage,
// Réquisition) des organisations, établissements, adhésions, listes de diffusion
// et capacités. 'shelter' est l'ancien identifiant de « Prise en charge ».

const REMOVED_ACTIVITY_IDS = ['refuge', 'shelter', 'guarding', 'requisition']

const pullActivities = path => ({
    filter: {[path]: {$in: REMOVED_ACTIVITY_IDS}},
    update: {$pull: {[path]: {$in: REMOVED_ACTIVITY_IDS}}}
})

async function applyJob() {
    const targets = [
        {label: 'organisation(s)', collection: global.app.C.Organization.collection, ...pullActivities('activities')},
        {label: 'établissement(s)', collection: global.app.C.Shelter.collection, ...pullActivities('types')},
        {label: 'adhésion(s)', collection: global.app.C.Adhesion.collection, ...pullActivities('types')},
        {label: "établissement(s) d'adhésion", collection: global.app.C.AdhesionShelter.collection, ...pullActivities('types')},
        {label: 'liste(s) de diffusion', collection: global.app.C.BroadcastListPlatform.collection, ...pullActivities('organizationActivity')},
        {
            label: 'capacité(s)',
            collection: global.app.C.Capacity.collection,
            filter: {$or: REMOVED_ACTIVITY_IDS.map(id => ({[id]: {$exists: true}}))},
            update: {$unset: REMOVED_ACTIVITY_IDS.reduce((acc, id) => ({...acc, [id]: ''}), {})}
        }
    ]

    const results = []
    for (const {label, collection, filter, update} of targets) {
        const result = await collection.updateMany(filter, update)
        results.push(`${result.modifiedCount} ${label}`)
    }
    return {message: `Activités supprimées retirées : ${results.join(', ')}`}
}

export const job = {
    name: "adaptRemovedActivities",
    title: "Retirer les activités supprimées (Prise en charge, Gardiennage, Réquisition)",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
